module.exports = __webpack_public_path__ + "static/img/custom.7c47f62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom.png
// module id = 6IE7
// module chunks = 1